import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';
import Icon, { GLYPHS } from '../../common/icon';
import UploadPhoto from '../../common/uploadPhotoForm/uploadPhoto';

const UploadLogo = ({ name }) => (
  <UploadPhoto name={name} className="c-avatar-upload">
    {(imageUrl) => {
      if (imageUrl) return <img src={imageUrl} className="c-avatar-upload__img c-avatar-upload__img--square" alt="" />;
      return (
        <div className="u-inline-block">
          <div className="c-add-avatar u-inline-block u-mr-">
            <Icon glyph={GLYPHS.addPhoto} size="medium" />
          </div>
          <div className="c-heading c-heading--small u-inline-block">{t('admin:shops.add.upload_logo')}</div>
        </div>
      );
    }}
  </UploadPhoto>
);
UploadLogo.propTypes = {
  name: PropTypes.string.isRequired,
};
UploadLogo.defaultProps = {};

export default UploadLogo;
